module.exports = __webpack_public_path__ + "img/icon_day.e836ad04.png";